import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";
import Single from "./pages/single/Single";
import NewTicketOpen from "./pages/newTicketOpen/NewTicketOpen";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import {
    ticketClosedInputs,
    ticketCloseeInputs,
    ticketSolvedInputs,
    ticketUpdateInputs, ticketUpdateLocalsite,
    userInputs,
} from "./formSource";
import "./style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import New from "./pages/new/New";
import {AuthContext} from "./context/AuthContext";
import {ticketOpenColumns} from "./components/datatableTicketSolve/dataticketopen";
import {
    SiteLocalColumns,
    TickeClosecolumns,
    ticketDetailcolumns,
    ticketDetailLocalSitecolumns,
    ticketSolvedColumns,
    userColumns
} from "./datatablesource";
import SingleOpenTicket from "./pages/singleTicketOpen/SingleOpenTicket";
import UpdateTicketOpen from "./pages/UpdateTicket/UpdateTicketOpen";
import SingleClosedTicket from "./pages/singleTicketClosed/SingleClosedTicket";
import ListSolved from "./pages/listSolved/ListSolved";
import NewTicketSolved from "./pages/newTicketSolved/NewTicketSolved";
import UpdateTicketSolved from "./pages/UpdateTicketSolved/UpdateTicketSolved";
import NewTicketClosed from "./pages/newTicketClosed/NewTicketClosed";
import UpdateTicketClosed from "./pages/UpdateTicketClosed/UpdateTicketClosed";
import SingleSolvedTicket from "./pages/singleTicketSolve/SingleSolvedTicket";
import SingleUser from "./pages/singleUsers/SingleUser";
import UpdateUsersById from "./pages/UpdateUsersById/UpdateUsersById";
import ListUsers from "./pages/listUsers/ListUsers";
import ListDetail from "./pages/listDetail/ListDetail";
import UpdateUsersCurrent from "./pages/UpdateUsersCurrent/UpdateUsersCurrent";
import NotFound from "./pages/notFound/404";
import ListClosed from "./pages/listClosed/ListClosed";
import UpdateTicketTimeSolved from "./pages/UpdateTicketTimeSolved/UpdateTicketTimeSolved";
import ListDetailLocalSite from "./pages/TicketLocalSitePage/listLocalSite/ListDetailLocalSite";
import NewTicketOpenLocalSite from "./pages/TicketLocalSitePage/NewTicketOpenLocalSite/NewTicketOpenLocalSite";
import SingleOpenTicketLocalSite from "./pages/TicketLocalSitePage/SingleOpenTicketLocalSite/SingleOpenTicketLocalSite";
import UpdatePendingTicketLocalTime from "./pages/TicketLocalSitePage/UpdatePendingTicketLocalTime/UpdatePendingTicketLocalTime";
import UpdateTicketLocalSite from "./pages/TicketLocalSitePage/UpdateTicketLocal/UpdateTicketLocalSite";
import ListDetailLocalSiteQuery from "./pages/TicketLocalSitePage/listLocalSiteQuery/ListDetailLocalSiteQuery";
import NewTicketSingleMass from "./pages/newTicketSingleMassDisruption/NewTicketSingleMass";
import ListLocalSiteName from "./pages/TicketLocalSitePage/listLocalSiteName/ListLocalSiteName";
import SingleLocalSite from "./pages/TicketLocalSitePage/singleLocalSite/SingleLocalSite";
import OpenTicketSingleID from "./pages/TicketLocalSitePage/OpenTicketWithSiteId/OpenTicketSingleID";
import NewLocalSite from "./pages/TicketLocalSitePage/NewLocalSite/NewLocalSite";
import DataTableMassLocalSite from "./pages/TicketLocalSitePage/DataTableMassLocalSite/DataTableMassLocalSite";
import NewTicketSingleMassLocalsite
    from "./pages/TicketLocalSitePage/NewTicketSinggleMassLocalSite/NewTicketSinggleMassLocalSite";
import UpdateTicketLocalTime from "./pages/TicketLocalSitePage/UpdateTicketLocalTime/updateTicketLocalTime";
import UpdateLocalSite from "./pages/TicketLocalSitePage/UpdateLocalSite/UpdateLocalSite";

function App() {
  const { darkMode } = useContext(DarkModeContext);
  const ProtectedRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (!user) {
      return <Navigate to="/login" />;
    }

    return children;
  };

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <BrowserRouter>
        <Routes>
            <Route path="/">
              <Route path="login" element={<Login />} />
              <Route
                  index
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
              />
            <Route path="users">
              <Route
                  index
                  element={
                      <ProtectedRoute>
                  <ListUsers columns={userColumns}  />
                          </ProtectedRoute>
                }
                />
                <Route path="update/:userId" element={
                <ProtectedRoute>
                    <UpdateUsersById title="Update Users By Id" />
                </ProtectedRoute>
                } />
                <Route path="_current" element={
                    <ProtectedRoute>
                        <SingleUser />
                    </ProtectedRoute>
                } />
                <Route path="_current/update" element={
                    <ProtectedRoute>
                        <UpdateUsersCurrent />
                    </ProtectedRoute>
                } />

              <Route path=":userId" element={
                  <ProtectedRoute>
                      <Single />
                  </ProtectedRoute>
              } />
              <Route
                path="new"
                element={
                    <ProtectedRoute>
                  <New inputs={userInputs} title="Add New User" />
                    </ProtectedRoute>
              }
              />
            </Route>
            <Route path="ticket">
              <Route index element={
                  <ProtectedRoute>
                  <List columns={ticketOpenColumns} />
                  </ProtectedRoute>
              }
              />
              <Route path=":ticketId"
                     element={
                         <ProtectedRoute>
                         <SingleOpenTicket />
                         </ProtectedRoute>
                     } />
              <Route
                path="new"
                element={
                    <ProtectedRoute>
                    <NewTicketOpen
                      title="Add New Ticket Open"
                  />
                    </ProtectedRoute>
                }
              />

                <Route
                    path="bali"
                    element={
                        <ProtectedRoute>
                            <NewTicketOpen
                                title="Add New Ticket Open Bali"
                                region="Bali"
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="lampung"
                    element={
                        <ProtectedRoute>
                            <NewTicketOpen
                                title="Add New Ticket Open Lampung"
                                region="Lampung"
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="yogyakarta"
                    element={
                        <ProtectedRoute>
                            <NewTicketOpen
                                title="Add New Ticket Open Yogyakarta"
                                region="yogyakarta"
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="sulawesi"
                    element={
                        <ProtectedRoute>
                            <NewTicketOpen
                                title="Add New Ticket Open Sulawesi"
                                region="sulawesi"
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="Banten"
                    element={
                        <ProtectedRoute>
                            <NewTicketOpen
                                title="Add New Ticket Open Banten"
                                region="Banten"
                            />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="jakarta"
                    element={
                        <ProtectedRoute>
                            <NewTicketOpen
                                title="Add New Ticket Open JABODETABEK"
                                region="JABODETABEK"
                            />
                        </ProtectedRoute>
                    }
                />
                <Route path="update">
                    <Route path=":ticketId"
                           element={
                               <ProtectedRoute>
                                   <UpdateTicketOpen
                                       inputs={ticketUpdateInputs}
                                       title="Update Ticket Open"/>
                               </ProtectedRoute>
                           }
                    />
                </Route>
            </Route>
            <Route path="solve">
                <Route index element={
                    <ProtectedRoute>
                        <ListSolved columns={ticketSolvedColumns}  />
                    </ProtectedRoute>

                }
                />
                <Route path=":ticketId"
                       element={
                           <ProtectedRoute>
                               <SingleSolvedTicket />
                           </ProtectedRoute>
                       } />
                <Route
                    path="create/:ticketId"
                    element={
                        <ProtectedRoute>
                        <NewTicketSolved
                            inputs={ticketSolvedInputs}
                            title="Add New Ticket Solved"
                        />
                            </ProtectedRoute>
                                }
                />
                <Route
                    path="update/:ticketId"
                    element={
                        <ProtectedRoute>
                        <UpdateTicketSolved
                            inputs={ticketSolvedInputs}
                            title="Update Ticket Solved"
                        />
                            </ProtectedRoute>
                                }
                />
                <Route
                    path="time/:ticketId"
                    element={
                        <ProtectedRoute>
                            <UpdateTicketTimeSolved
                                title="Update Time Aging Ticket Solved"
                            />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="mass/:ticketId"
                    element={
                        <ProtectedRoute>
                            <NewTicketSingleMass
                                title="Generate Single Ticket GANGGUAN MASSAL"
                            />
                        </ProtectedRoute>
                    }
                />

            </Route>
                <Route path="closed">
                    <Route index element={
                        <ProtectedRoute>
                            <ListClosed columns={TickeClosecolumns}  />
                        </ProtectedRoute>

                    }
                    />
                    <Route path=":ticketId"
                           element={
                               <ProtectedRoute>
                                   <SingleClosedTicket  />
                               </ProtectedRoute>
                           } />
                    <Route
                        path="update/:ticketId"
                        element={
                            <ProtectedRoute>
                            <UpdateTicketClosed
                                inputs={ticketClosedInputs}
                                title="Update Ticket Closed"

                            />
                            </ProtectedRoute>
                        }

                    />
                    <Route
                        path="create/:ticketId"
                        element={
                            <ProtectedRoute>
                            <NewTicketClosed
                                inputs={ticketCloseeInputs}
                                title="Add New Ticket Closed"
                            />
                            </ProtectedRoute>}
                    />


                </Route>
                <Route path="detail">
                    <Route index element={
                        <ProtectedRoute>
                            <ListDetail columns={ticketDetailcolumns}  />
                        </ProtectedRoute>

                    }
                    />
                    <Route path=":ticketId"
                           element={
                               <ProtectedRoute>
                               </ProtectedRoute>
                           } />

                </Route>
                <Route path="ticketsite">

                    <Route index element={
                        <ProtectedRoute>
                            <ListDetailLocalSiteQuery columns={ticketDetailLocalSitecolumns}  />
                        </ProtectedRoute>

                    }
                    />
                    <Route path="export"
                           element={
                               <ProtectedRoute>
                                   <ListDetailLocalSite columns={ticketDetailLocalSitecolumns}  />
                               </ProtectedRoute>
                           } />
                    <Route path="new"
                           element={
                               <ProtectedRoute>
                                   <NewTicketOpenLocalSite title="Ticket Open Local Site" />

                               </ProtectedRoute>
                           } />
                    <Route path="update/:ticketId"
                           element={
                               <ProtectedRoute>
                                   <UpdateTicketLocalSite
                                       inputs={ticketUpdateLocalsite}
                                       title="Update Ticket Local Site"/>
                               </ProtectedRoute>
                           } />
                    <Route path="pending/time/:ticketId"
                           element={
                               <ProtectedRoute>
                                   <UpdatePendingTicketLocalTime title="Update Time Pending Ticket Local Site"
                                   />
                               </ProtectedRoute>
                           } />
                    <Route path="update/time/:ticketId"
                           element={
                               <ProtectedRoute>
                                   <UpdateTicketLocalTime title="Update Time Aging Ticket Local Site"
                                   />
                               </ProtectedRoute>
                           } />
                    <Route path=":ticketId"
                           element={
                               <ProtectedRoute>
                                   <SingleOpenTicketLocalSite />
                               </ProtectedRoute>
                           } />

                </Route>
                <Route path="localsite">

                    <Route index element={
                        <ProtectedRoute>
                            <ListLocalSiteName columns={SiteLocalColumns}  />
                        </ProtectedRoute>

                    }
                    />
                    <Route path=":siteId"
                           element={
                               <ProtectedRoute>
                                   <SingleLocalSite  />
                               </ProtectedRoute>
                           } />
                    <Route path="update/:siteId"
                           element={
                               <ProtectedRoute>
                                   <UpdateLocalSite  />
                               </ProtectedRoute>
                           } />
                    <Route path="new"
                           element={
                               <ProtectedRoute>
                                   <NewLocalSite  />
                               </ProtectedRoute>
                           } />
                    <Route path="open/:siteId"
                           element={
                               <ProtectedRoute>
                                   <OpenTicketSingleID  />
                               </ProtectedRoute>
                           } />
                    <Route path="update/time/:ticketId"
                           element={
                               <ProtectedRoute>
                               </ProtectedRoute>
                           } />
                    <Route path="update/pending/:ticketId"
                           element={
                               <ProtectedRoute>
                                   <UpdatePendingTicketLocalTime />

                               </ProtectedRoute>
                           } />
                    <Route path=":ticketId"
                           element={
                               <ProtectedRoute>
                               </ProtectedRoute>
                           } />

                </Route>


            </Route>
            <Route path="*" element={
                <NotFound/>
            } />
            <Route path="ticketlocal">
                <Route path="mass/:ticketId"
                       element={
                           <ProtectedRoute>
                               <NewTicketSingleMassLocalsite
                                   title="Generate Single Ticket GANGGUAN MASSAL Local Site"
                               />
                           </ProtectedRoute>
                       } />

            </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
